import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import {AuthService} from "../services/auth.service";

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html'
})
export class AppProfileSidebarComponent {

    constructor(public layoutService: LayoutService,
                private authService: AuthService) { }

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }

    logout(): void {
      this.authService.logout().subscribe();
    }
}
